import React, { useCallback, useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { DataTable,DisplayColumn } from '@jutro/legacy/datatable';
import { ViewModelForm,useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { Icon, ModalNextContext } from '@jutro/components';
import './UserAdminDetails.messages';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoaderExt } from 'gw-components-platform-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { useTranslator } from '@jutro/locale';
import { publish, unsubscribeAll } from '@jutro/events';
import metadata from './UserAdminDetails.metadata.json5';
import messages from '../UserAdministrationPage.messages';
import enrollmentData from '../util/userenrollment.json5';
import styles from './UserAdminDetails.module.scss';
import usecpmiAnalytics from '../../../hooks/usecpmiAnalytics'
import useGoogleAnalytics from '../../../hooks/useGoogleAnalytics';
import { forEach } from 'lodash';

import { Button } from '@jutro/legacy/components';

function UserAdminDetails(props) {
    const {
        history,
        location: {
            state: { 
                data: rowData,
                disableLossRunSubscription
            },
        },
        
    } = props;
    
    const ModalNext = useContext(ModalNextContext);
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    const auth = useAuthentication();
    

    const [enrollment, setEnrollment] = useState([enrollmentData]);
    const [grantData, setGrantData] = useState(rowData);
    const [userNotificationList, setUserNotificationList] = useState(rowData?.optIns?.filter((item)=>item?.itemName!=="ClaimsUpdate"));
    const [isLoading, setLoadingState] = useState(false);
    const [isTableLoad, setTableLoad] = useState(false);
    const translator = useTranslator();
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const [isUserAdmin, setIsUserAdmin] = useState(false);
    const [addUpdateAccountList, setaddUpdateAccountList] = useState([]);
    const[buttonDisableFlag,setButtonDisableFlag]=useState(false);
    const[allInvRemoved,setAllInvRemoved]=useState(undefined);
    const [clickedInvoiceStreamValue, setClickedInvoiceStreamValue] = useState();
    const [addRemoveInvoiceValue, setAddRemoveInvoiceValue] = useState();
    const [invFlag, setInvFlag] = useState(false);
    const [invoiceStreamNames,setInvoiceStreamNames] = useState([]);
    
    const NotificationDescription  = {
        BillingInvoiceReady: {
            name: "Invoice Ready",
            value: "An invoice has billed and is ready"
        },
        BillingInvoiceReminder : {
            name: "Invoice Reminder",
            value: "An invoice is unpaid and due soon"
        },
        NOC: {
            name: "Notice of Cancellation",
            value: "A Notice of Cancellation has been generated"
        },
        PayrollReport: {
            name: "Payroll Reminder",
            value: "A payroll report is unfinished and due soon"
        },
        Paperless: {
            name: "Paperless",
            value: "Paperless Notification"
        },
        ClaimsUpdate: {
            name: "Claims Update",
            value: "A claim has updated with change to status, reserves or maximum medical improvement"
        },
        NewDocument: {
            name: "New Document",
            value: "An account/policy document has been posted"
        },
        LossRunSubscription: {
            name: "Loss Run Subscription (PDF)",
            value: "Receive loss run report while at least one policy is in force"
        },
        LossRunSubscriptionXL: {
            name: "Loss Run Subscription (EXCEL)",
            value: "Receive loss run report while at least one policy is in force"
        }
    };

    const roleMapping = {
    "Basic User": "BASIC",
    "Policy": "POLICY",
    "Billing": "BILLING",
    "Payroll Reporting":"PAYROLL",
    "Claims":"CLAIM",
    "Account Admin":"USERADMIN",
    "View Resources/FAQ":"BASIC",
    "View policy details and policy documents, create Certificates of Insurance":"POLICY",
    "Make payments, view invoices":"BILLING",
    "Enter payroll reports, view payroll documents":"PAYROLL",
    "File a new claim, view claim notes and reports":"CLAIM",
    "Add and remove users, change user permissions, and all other authorities":"USERADMIN"

    }
 
    // eslint-disable-next-line array-callback-return
    // rowData.grantedAuthorities.map((accountInfo)=>{
    //     accountInfo.buttonText ="Remove Account"
    // })

    const getDisablilityByRoles=useCallback(()=>{
        rowData.roles.map((item) => {
            if(item.access==='USERADMIN'){
                setButtonDisableFlag(true)
            }
            
        })
    },[rowData.roles])

    useEffect(() => {
        publish('JUTRO_TOPICS.ROUTE_CHANGED', {
            path: '/admin-user-details',
            title: 'View User Details',
        });
    }, []);

    useEffect(()=>{

    },[invFlag])

    useEffect(() => {
        rowData.roles.map(item => {
            if (
                item.access === 'USERADMIN' &&
                item.isAccessGranted === true
            ) {
                return setIsUserAdmin(true);
            }
        });
    },[])
    useEffect(() => {
        trackPageView("User Admin Details", "/user-admin-details")
    },[])

    useEffect(() => {
        trackGAPageView("/user-admin-details","User Admin Details")
    },[])
    
    useEffect(()=>{
        getDisablilityByRoles();
    },[getDisablilityByRoles])


    useEffect(()=>{
        
    },[buttonDisableFlag])

    const getCell = (items, index, property) => {
        return !_.isObject(items[property.id]) ? <div style={{fontSize :"1.1rem"}}>{items[property.id]}</div> : null;        
    };

    const getDisability=()=>{
        if(rowData.emails[0].value===auth.userInfo.email)
        {
            return true
        }
        return false
       
    }    

    const getAllAccountsforCurrentUser = useCallback(() => {

        const tempVariable = props?.location?.state?.allAccountListCurrentUser;

        const temp = []
        // eslint-disable-next-line array-callback-return
        rowData.grantedAuthorities.filter((arr) => {
            temp.push(arr.accountNumber)
        })

        tempVariable.forEach((element) => {
            if (temp.includes(element.accountNumber)) {
                element.buttonText = "Remove Account"
            }

        });

        setaddUpdateAccountList(tempVariable);
        // return pp; 
        // const data = addUpdateAccountList;
        // return data;   

    }, [props?.location?.state?.allAccountListCurrentUser, rowData.grantedAuthorities])  

    useEffect(()=>{
        getAllAccountsforCurrentUser()
        // refreshData()
    },[getAllAccountsforCurrentUser])

    const renderAccessGranted = (item,index) => {
        if (item.role !== 'Basic User') {
            return <Button  disabled={getDisability()} style={{width:"152px", background:"#003057"}} id={ index} onClick={(e) => removeUserAccess(e,index,item)}>Remove</Button>;
        }
        return <Icon icon="mi-check" />;
    };

    const renderAddButton = item => {
        return <Button style={{width:"152px"}} onClick={e => handleAddAccess(e, item)}>Add</Button>;
    };

    const handleAddAccess = useCallback(
        (e, item) => {
            e.preventDefault();
            console.log("role map name ", roleMapping[item.nlrole])
            const data = [
                rowData.userName,
                {
                    access: roleMapping[item.nlrole],
                    description: item.nlauthDescr,
                    isAccessGranted: true,
                },
            ];
            setLoadingState(true);
            EnrollmentService.addUserAccess(data, authHeader)
                .then(result => {
                    let updatedGrantData = {...grantData};
                    updatedGrantData.roles.map(i => {
                        if(translator(messages[i.access]) === item.nlrole)
                        {
                            return i.isAccessGranted=true;
                        }
                    })

                    return setGrantData(updatedGrantData);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [rowData]
    );
    const showAlertForNotifications = useCallback(() => {
        ModalNext.showAlert({
            title: 'There was an error updating the activity',
            message: 'Please try again later',
            status: 'error',
            icon: 'mi-error-outline'          
        });
    },[ModalNext]);

    const updateNotification = useCallback(
        (e, item) => {
            e.preventDefault();
            // const data = [rowData.userName, 1];
            setLoadingState(true);
            let filteredInvoices = _.filter(invoiceStreamNames, (inv) => {       
                return inv != null
            });
            EnrollmentService.updateNotificationAlert(rowData.userName, item.portalOptInItemID, filteredInvoices,authHeader)
                .then((result) => {
                    if(result){
                        let updatedOptIns = [...rowData.optIns];
                        updatedOptIns.forEach((optins) => { 
                            if (optins.portalOptInItemID === item.portalOptInItemID){
                                optins.selected = true;
                            }
                        })
                        setUserNotificationList(updatedOptIns);
                    } else {
                        showAlertForNotifications();
                    }
                    // setEnrollment(updatedItems);
                }).catch(() => {
                    showAlertForNotifications();
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [rowData, enrollment, authHeader,invoiceStreamNames]
    );

    const deleteNotification = useCallback(
        (e, item) => {
            e.preventDefault();
            // const data = [rowData.userName, 1];
            setLoadingState(true);
            EnrollmentService.deleteNotificationAlert(rowData.userName, item.portalOptInItemID, authHeader)
                .then(result => {
                    if(result){
                        let updatedOptIns = [...rowData.optIns];
                        updatedOptIns.forEach((optins) => { 
                            if (optins.portalOptInItemID === item.portalOptInItemID){
                                optins.selected = false;
                            }
                        })
                        setUserNotificationList(updatedOptIns);
                    } else {
                        showAlertForNotifications();
                    }
                    // setEnrollment(updatedItems);
                }).catch(() => {
                    showAlertForNotifications();
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [rowData]
    );

    const renderButton = useCallback(
        rowData => {
            rowData.roles.map(item => {
                if (
                    item.access === 'USERADMIN' &&
                    item.isAccessGranted === true
                ) {
                    return setIsUserAdmin(true);
                }
            });
        },
        [rowData]
    );

    const getGrantListData = useCallback(() => {
        let data;
        data = grantData.roles.filter((role) => {
            return role.isAccessGranted === true && role.isInvoiceAccess === false;
        });

        return data
            .map(row => {
                console.log("role in row ", row.access)
                return {
                    role: translator(messages[row.access]),
                    authDescr: row.description,
                    remove: row.isAccessGranted,
                };
            })
            .sort((a, b) => {
                return a.name - b.name;
            });
    }, [grantData.roles, translator]);

    const getBackToPreviousState = () => {
        history.push('user-administration');
    };

   

    const grantNotListedData = useCallback(() => {
        const data = rowData.roles.filter(r => {
            return r.isAccessGranted === false;
        });
        return rowData.roles
            .filter(item => {
                return item.isAccessGranted === false;
            })
            .map(role => {
                return {
                    nlrole: translator(messages[role.access]),
                    // nlrole: role.access,
                    nlauthDescr: role.description,
                    nladd: role.isAccessGranted,
                };
            });
    }, [rowData, renderButton]);    

    const removeUser =  () => {
        // e.preventDefault();
        return ModalNext.showConfirm({
            title: <div className={styles.removeUserPopup}>{translator(messages.removeUserMessage)}</div>,
           // status: 'info',
           // icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
            cancelButtonText: commonMessages.noModel,
        }).then(async(results) => {
            if (results === 'confirm') {
                const user = rowData.userName;
                await EnrollmentService.removeUser(user, authHeader).then(res =>
                    console.log('results from remove user ', res)
                );
                return history.push('user-administration');
            }
        }, _.noop);
    };

    const addNewAccountButtonClick = useCallback((e,index,item)=>{
        let addInvoiceNames = [];
        item.invoiceStreams.map((invoiceNames) => {
            addInvoiceNames.push(invoiceNames);
        })
        setInvoiceStreamNames([...addInvoiceNames,...invoiceStreamNames])
       // setLoadingState(true);
       setTableLoad(true)
        const invoiceSTreamsArray = [];

        // eslint-disable-next-line array-callback-return
        item.invoiceStreams.map((invoiceStreamItem)=>{
            invoiceSTreamsArray.push({
                access: item.accountNumber,
                description: invoiceStreamItem.replace(/\s/g, ''),
                invoiceId: Object.keys(item.invoiceStreamMap).find((key) => item.invoiceStreamMap[key] === invoiceStreamItem),
                isAccessGranted: true,
                isInvoiceAccess: true
            })
        })

        const authorityData = [];
        // eslint-disable-next-line array-callback-return
        rowData?.roles.map((dataItem)=>{
            if(dataItem.isInvoiceAccess === false){
                authorityData.push(dataItem);
            }
        })
        invoiceSTreamsArray.map((arrayItem)=>{
            authorityData.push(arrayItem); 
        })
       
        const grantedAuthorities = { 
            accountNumber:item.accountNumber,
            accountName:item.accountName,
            authority:authorityData//rowData.roles
        };

        EnrollmentService.addAuthority(rowData.userName,grantedAuthorities, authHeader)
            .then(result => {
                item.buttonText = "Remove Account";
                refreshData();    
                setInvFlag(false)          
            })
            .catch(()=>{
                ModalNext.showAlert({
                    title: 'Error',
                    message: 'Something went wrong with API call',
                    status: 'error',
                    icon: 'mi-error-outline'  ,
                    confirmButtonText: "Close",       
                });

                
            })
            .finally(() => {
                //setLoadingState(false);
                setTableLoad(false)
                setInvFlag(false)
                setAllInvRemoved(item.accountNumber)
            });
    },[ModalNext, authHeader, refreshData, rowData.roles, rowData.userName,invoiceStreamNames, setInvFlag, setAllInvRemoved])

    const removeAccountNumberButtonClick = useCallback(
        (e, index, item) => {
            let removeInvoiceNames=[];
            removeInvoiceNames=invoiceStreamNames.filter((names)=>!item.invoiceStreams.includes(names))
            setInvoiceStreamNames(removeInvoiceNames);
            //setLoadingState(true);
            setTableLoad(true)
            EnrollmentService.removeAuthority(rowData.userName,item.accountNumber, authHeader)
                .then(result => {
                    item.buttonText = "Add Account"
                    refreshData();            
                })
                .catch(()=>{
                    ModalNext.showAlert({
                        title: 'Error',
                        message: 'Something went wrong with API call',
                        status: 'error',
                        icon: 'mi-error-outline'  ,
                        confirmButtonText: "Close",       
                    });
                    
                })
                .finally(() => {
                    ///setLoadingState(false);
                    setTableLoad(false)
                });
        },[invoiceStreamNames, rowData.userName, authHeader, refreshData, ModalNext])

    const removeUserAccess = useCallback(
        (e, index, item) => {
            e.preventDefault();
            const accessInfo = {
                access: roleMapping[item.role],
                description:item.authDescr,
                isAccessGranted:false
            }
            const data = [rowData.userName, accessInfo];
            setLoadingState(true);
            EnrollmentService.removeUserAccess(data, authHeader)
                .then(result => {

                    let updatedGrantData = {...grantData};
                    updatedGrantData.roles.map(i => {
                        if(translator(messages[i.access]) === item.role)
                        {
                            return i.isAccessGranted=false;
                        }
                    })

                    return setGrantData(updatedGrantData);

                })
                .catch(()=>{
                    ModalNext.showAlert({
                        title: 'Error',
                        message: 'There must be at least 1 user with Account Admin Role',
                        status: 'error',
                        icon: 'mi-error-outline'  ,
                        confirmButtonText: "Close",       
                    });
                    
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [rowData]
    );

    const getEnrollmentNotifications = useCallback(() => {
        return enrollment.map(item => {
            return {
                activity: item.activity,
                desc: item.description,
                access: item.access,
                action: item.action,
            };
        });
    }, [enrollment]);

    const renderAddAccountButton = useCallback((item, index) => {
        let renderAddRemoveButton = '';
        
        const allAccountsForCurrentUser = props?.location?.state?.allAccountListCurrentUser;
        
        const filteredRes=allAccountsForCurrentUser.filter((results)=>results.buttonText === "Remove Account")
        if (item.buttonText === "Remove Account") {
            // eslint-disable-next-line no-const-assign
            
            renderAddRemoveButton= <Button style={{ width: "152px", background: item.buttonText === "Remove Account" ? 'rgb(0, 48, 87)' : "" }}
                disabled={((buttonDisableFlag && getDisability()) || isTableLoad) || filteredRes.length === 1} 
                onClick={(e) => removeAccountNumberButtonClick(e, index, item)}>{item.buttonText}</Button>;
        } else {
            // eslint-disable-next-line no-const-assign
            renderAddRemoveButton= <Button style={{ width: "152px", background: item.buttonText === "Remove Account" ? 'rgb(0, 48, 87)' : "" }}
                disabled={isTableLoad}
                onClick={(e) => addNewAccountButtonClick(e, index, item)}>{item.buttonText}</Button>;
        }
        // eslint-disable-next-line react/react-in-jsx-scope

        return renderAddRemoveButton;

    }, [addNewAccountButtonClick, buttonDisableFlag, getDisability, props?.location?.state?.allAccountListCurrentUser, removeAccountNumberButtonClick,invoiceStreamNames])


    const renderDescription = item => {
        const items = item.desc.map((val, id) => {
            return <li id={id}>{val}</li>;
        });
        return <div className={styles.enrollDescrList}>{items}</div>;
    };

    const renderAccess = item => {
        if (item.access === 'yes') {
            return <Icon icon="mi-check" />;
        }
    };

    const renderAction = item => {
        if (item.action === 'na') {
            return <Icon icon="mi-check" />;
        } else if (item.action === 'yes') {
            return (
                <Button style={{width:"152px"}} onClick={e => updateNotification(e, item)}>
                    Grant
                </Button>
            );
        } else if (item.action === 'no') {
            return (
                <Button style={{width:"152px", background:"#003057"}} onClick={e => deleteNotification(e, item)}>
                    Remove
                </Button>
            );
        }
    };
    const getNotificationName = (item) => {
        return <div style={{fontSize :"1.1rem"}}>{NotificationDescription[item?.itemName]?.name}</div>;        
    };
    const getNotificationDesc = (item) => {
        return <div style={{fontSize :"1.1rem"}}>{NotificationDescription[item?.itemName]?.value}</div>;        
    };
    const getNotificationAccess = (item) => {
        const notificationCheck = userNotificationList.find((i) => i.itemName === item.itemName);
        if (notificationCheck.selected) {
            return <Icon icon="mi-check" />;
        }
    };
    const getNotificationAction = (item, index) => {
        const notificationCheck = userNotificationList.find((i) => i.itemName === item.itemName);
        if(notificationCheck.selected) {
            return <Button style={{"min-width":"152px",background:"#003057"}} id={index} onClick={(e) => deleteNotification(e, item)}>Remove Receipt</Button>;
        }
        return <Button disabled= {disableLossRunSubscription && (item.itemName === 'LossRunSubscription' || item.itemName === 'LossRunSubscriptionXL')} style={{"min-width":"152px"}} id={index} onClick={(e) => updateNotification(e, item)}>Add Receipt</Button>;
    };
    const getAccountNumber = (item)=>{
        return <div style={{fontSize :"1.1rem"}}>{item.accountNumber}</div>;
    }
    const removeInvoiceStream=useCallback((e,item)=>{
        if(item.buttonValue === "Remove"){
            item.buttonValue ="Add";
        }else{
            item.buttonValue ="Remove";
        }
        let removeInvoiceNames=[];
        removeInvoiceNames=invoiceStreamNames.filter((names)=>names!==item.invName)
        setInvoiceStreamNames(removeInvoiceNames)
        setInvFlag(true);
        refreshData();
        const data = [
            rowData.userName,
            {
                access: item.accountNumber,
                description: item.invName.replace(/\s/g, ''),
                isAccessGranted: false,
                invoiceId: item.invId
            },
        ];
        // setLoadingState(true);
        EnrollmentService.removeUserAccess(data, authHeader)
            .then((result) => {
                setClickedInvoiceStreamValue(item.invId);
            })
            .finally(() => {
                
            });
    },[refreshData,invoiceStreamNames])
    
    const addInvoiceStream = useCallback((e, item) => {
        if(item.buttonValue === "Remove"){
            item.buttonValue ="Add";
        }else{
            item.buttonValue ="Remove";
        }
        setInvoiceStreamNames([item.invName,...invoiceStreamNames])
        setInvFlag(true);
        refreshData();
        const data = [
            rowData.userName,
            {
                access: item.accountNumber,
                description: item.invName.replace(/\s/g, ''),
                isAccessGranted: true,
                invoiceId: item.invId
            },
        ];
        //setLoadingState(true);
        EnrollmentService.addUserAccess(data, authHeader)
            .then((result) => { 
                setClickedInvoiceStreamValue(item.invId);  
            })
            .finally(() => {
                
            });
        
    },[refreshData,invoiceStreamNames])


    
  

    const renderButtonAction=(item,tableDataValues)=>{ 
        const filterData = tableDataValues?.filter((l)=>l?.buttonValue ==="Add");
        const buttonDisabled = (tableDataValues?.length - filterData?.length) ===1
        setInvFlag(true);
        if(item.buttonValue === "Add"){
            // eslint-disable-next-line react/react-in-jsx-scope
            //return <Button style={{ "width": "152px" }} id={item.invName} onClick={(e) => addInvoiceStream(e, item)}>{item.buttonValue}</Button>
            return <Button style={{ "width": "152px" }} id={item.invName} onClick={(e) => addInvoiceStream(e, item)} disabled={item.buttonEnableDisabled !=="Enabled" || getDisability()}>{item.buttonValue}</Button>
            
        }
        // eslint-disable-next-line react/react-in-jsx-scope
        // return <Button style={{ width: "152px", background: "#003057" }} id={item.invName} onClick={(e) => removeInvoiceStream(e, item)}>{item.buttonValue}</Button>
        return <Button style={{ width: "152px", background: "#003057" }} id={item.invName} onClick={(e) => removeInvoiceStream(e, item)} disabled={item.buttonEnableDisabled !=="Enabled" || buttonDisabled || getDisability()}>{item.buttonValue}</Button>
        
       
    }
   

    const renderRowData = (row) => {
        if(row.buttonText==="Remove Account" && row.invoiceStreamCount >0){
            //setInvFlag(false);
            if (row.invoiceStreamName === undefined) {

                row.invoiceStreamName = [];
                if (rowData.emails[0].value === auth.userInfo.email) {
                    rowData?.allAccountListCurrentUser?.map((items) => {
                       
                        let unMatchInvoice = []
                        unMatchInvoice = items?.actualInvoiceSteamArray.filter((res) => !items?.invoiceStreams.includes(res))
                      
                        // row.invoiceStreamName = [];
                        if (items?.actualInvoiceSteamArray.length > 1) {
                            if (unMatchInvoice?.length >= 1) {
                                unMatchInvoice?.map((uni) => {
                                    if (items.accountNumber === row.accountNumber) {
                                        row.invoiceStreamName.push({
                                            invName: uni,
                                            invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === uni),
                                            accountNumber: row.accountNumber,
                                            buttonValue: "Add",
                                            buttonEnableDisabled: "Enabled"
                                        })
                                    }
                                })
                            }
                        }

                    })
                    row.invoiceStreams.map((itenm) => {                        
                        row.invoiceStreamName.push({
                            invName: itenm,          
                            invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),                  
                            accountNumber: row.accountNumber,
                            buttonValue:  "Remove",
                            buttonEnableDisabled: "Enabled"
                        })
                    })

                }
                else {
                    row.invoiceStreams.map((itenm) => {
                        const invId =Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm)  
                        const allInvAccess = rowData?.roles?.filter((h) => h?.access === row.accountNumber);                      
                        const filterInvoiceItem = rowData?.roles?.find((h) => h?.invoiceId === invId);
                        row.invoiceStreamName.push({
                            invName: itenm,
                            invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),   
                            accountNumber: row.accountNumber,
                            buttonValue: filterInvoiceItem !== undefined || (allInvRemoved === row.accountNumber) ? "Remove" : "Add",
                            buttonEnableDisabled: (row.invoiceStreamCount > 1 && row.accessTrueMultiInvoiceCount === 1) ? "Disabled" : "Enabled"
                        })
                    })
                }



                // eslint-disable-next-line array-callback-return


                // setInvoiceDataSet(row.invoiceStreamName);
                // refreshData();
            }
            
            if (invFlag === false && (allInvRemoved === undefined || allInvRemoved === row.accountNumber)) {
                row.invoiceStreamName = [];
                //eslint-disable-next-line array-callback-return
                if (rowData.emails[0].value === auth.userInfo.email) {
                   
                    rowData?.allAccountListCurrentUser.map((items) => {
                       
                        let unMatchInvoice = []
                        unMatchInvoice = items.actualInvoiceSteamArray.filter((res) => !items.invoiceStreams.includes(res))
                       
                        // row.invoiceStreamName = [];
                        if (items?.actualInvoiceSteamArray?.length > 1) {
                            if (unMatchInvoice?.length >= 1) {
                                unMatchInvoice.map((uni) => {
                                    if (items.accountNumber === row.accountNumber) {
                                        const invId =Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] ===  uni)
                                        const filterInvoiceItem = rowData?.roles?.find((h) => h?.invoiceId === invId);
                                        row.invoiceStreamName.push({
                                            invName: uni,
                                            invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === uni),   
                                            accountNumber: row.accountNumber,
                                            buttonValue: filterInvoiceItem !== undefined ? "Remove" : "Add",
                                            buttonEnableDisabled: "Enabled"
                                        })
                                    }
                                })
                            }
                        }
                    })
                    row.invoiceStreams.map((itenm) => {
                        const invId =Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm)
                        const filterInvoiceItem = rowData?.roles?.find((h) => h?.invoiceId === invId);
                        row.invoiceStreamName.push({
                            invName: itenm,
                            invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),   
                            accountNumber: row.accountNumber,
                            buttonValue: filterInvoiceItem !== undefined ? "Remove" : "Add",
                            buttonEnableDisabled: "Enabled"
                        })
                    })

                }
                else {
                    row.invoiceStreams.map((itenm) => {
                        const invId =Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm)
                        const allInvAccess = rowData?.roles?.filter((h) => h?.access === row.accountNumber);
                        const filterInvoiceItem = rowData?.roles?.find((h) => h?.invoiceId === invId);
                        row.invoiceStreamName.push({
                            invName: itenm,
                            invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm), 
                            accountNumber: row.accountNumber,
                            buttonValue: filterInvoiceItem !== undefined || (allInvRemoved === row.accountNumber) ? "Remove" : "Add",
                            buttonEnableDisabled: (row.invoiceStreamCount > 1 && row.accessTrueMultiInvoiceCount === 1) ? "Disabled" : "Enabled"
                        })
                    })
                }

                // setInvoiceDataSet(row.invoiceStreamName);
                // refreshData();
            }

        if(row.invoiceStreamCount > 1){
            return(
                <DataTable
                    columnsConfigurable={false}
                    data={row.invoiceStreamName}
                    
                    defaultConfig={{
                        page: 0,
                        pageSize: 10
                    }}
                    id="basic"
                    showPagination={false}
                    showSearch={false}
                    isSorted={false}
                >
                    <DisplayColumn
                        header="Invoice Name"
                        id="invName"
                        cell={(row) => <span className={styles.columnFontCls}>{row.invName}</span>}
                        textAlign="left"
                        columnProportion={0.69}
                    />
                    <DisplayColumn
                        header="Action"
                        id="AddRemoveBtn"
                        sortable={false}
                        renderCell={(item)=>renderButtonAction(item,row.invoiceStreamName)}
                        textAlign="left"
                        columnProportion={0.13}
                        
                    />
                    
                </DataTable>
            ) 
        }
        
            return (<></>)
            
           
       
    }
        
    
    }

    const getUpdatedInvoiceNames=useCallback(()=>{
        const tempVariable = props?.location?.state?.allAccountListCurrentUser;
        let invoiceDisplayNames=[]
        let finalInvs = []
        var invData = grantData.roles.filter((role) => {
            return role.isAccessGranted === true && role.isInvoiceAccess === true;
        });

        const temp = []
        const invMap =
        // eslint-disable-next-line array-callback-return
        rowData.grantedAuthorities.filter((arr) => {
            temp.push(arr.accountNumber)
        })

        tempVariable.forEach((element) => {
            if (temp.includes(element.accountNumber)) {
                element.buttonText = "Remove Account"
            }

        });

        tempVariable.map((item1) => {            
            if (item1.buttonText === "Remove Account") {
                Object.keys(item1.invoiceStreamMap).forEach((key) => {
                    let invData = {};

                    invData.key =key
                    invData.value = item1.invoiceStreamMap[key]
                    invoiceDisplayNames.push(invData)
                })                
            }            
        })
        invData.forEach((inv) => {
            
            var a = _.find(invoiceDisplayNames, (invDis) => invDis?.key === inv.invoiceId)

            if(a !== undefined){
                finalInvs.push(a.value)
            }            
        });        
        setInvoiceStreamNames(finalInvs)
       
    },[addUpdateAccountList, grantData])

    useEffect(()=>{
        getUpdatedInvoiceNames();
    },[getUpdatedInvoiceNames])


    const getAccountName = (item)=><div style={{fontSize :"1.1rem"}}>{item.accountName}</div>

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

    const overrides = {                      
        authname: {
            value: rowData.name.givenName + ' ' + rowData.name.familyName,
        },
        grantListTable: {
            data: getGrantListData(),
        },
        removeBtn: {
            visible: !isUserAdmin,
            // onClick:removeUser(rowData)
        },
        grantNotListTable: {
            data: grantNotListedData(),
        },
        elecNotifListTable: {
            // data: getEnrollmentNotifications()
            data: userNotificationList?.filter((op)=>op?.itemName!=="ClaimsUpdate") || []
        },
        addUpdateListTable: {
            // data:getAllAccountsforCurrentUser()
            data: addUpdateAccountList || [],                    
        },
        notesLoader: {
            loaded: !isTableLoad,
        }
      
        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
            getRole: getCell,
            getAuthDescription: getCell,
            renderRemove: renderAccessGranted,
            getActivity: getCell,
            renderButton,
            getNLRole: getCell,
            getnlAuthDescription: getCell,
            getEnrolled: getCell,
            getAction: getCell,
            rendernlAdd: renderAddButton,
            getDescription: renderDescription,
            renderEnrolled: renderAccess,
            getEnrolledAction: renderAction,
            getBackToPreviousState,
            handleAddAccess,
            removeUser,
            getNotificationName,
            getNotificationDesc,
            getNotificationAccess,
            getNotificationAction,
            getAccountNumber,
            getAccountName,
            renderAddAccountButton,
            addInvoiceStream,
            removeInvoiceStream,
            renderRowData,
            getUpdatedInvoiceNames:getUpdatedInvoiceNames,
            // ,getAllAccountsforCurrentUser
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={rowData}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

export default withRouter(UserAdminDetails);
